import _ from "lodash";

export const getAttributeBankName  = state => _.get(state,['withdraw','withdrawData', 'attributes', 'esp', 'esp_bank_name'],null)
export const getWithdrawData  = state => _.get(state,['withdraw','withdrawData'],null)
export const getWithdrawClientCode  = state => _.get(state,['withdraw','withdrawData', 'clientCode', 'text'],null)
export const getWithdrawBankAccount  = state => _.get(state,['withdraw','withdrawData', 'bankAccount'],null)
export const getWithdrawTotalAmount  = state => _.get(state,['withdraw','withdrawData', 'totalAmount'],null)


//History
export const getEWithdrawCdsNumber = (eWithdraw) =>
    _.get(eWithdraw, ["items", "contract", "cds_number"], "");
export const getEWithdrawTransactionAmountValue = (eWithdraw) =>
    _.get(eWithdraw, ["transaction_amount", "value"], "");
export const getEWithdrawStatusText = (eWithdraw) =>
    _.get(eWithdraw, ["status", "text"], "");
export const getEWithdrawStatusValue = (eWithdraw) =>
    _.get(eWithdraw, ["status", "value"], "");
export const getEWithdrawClientCode = (eWithdraw) =>
    _.get(eWithdraw, ["client_code"], "");
export const getEWithdrawActionText = (eWithdraw) =>
    _.get(eWithdraw, ["action", "text"], "");
export const getEWithdrawAmountText = (eWithdraw) =>
    _.get(eWithdraw, ["transaction_amount", "text"], "");
export const getEWithdrawAmountFullText = (eWithdraw) =>
    _.get(eWithdraw, ["transaction_amount", "full_text"], "");
export const getEWithdrawCurrencyCodeText = (eWithdraw) =>
    _.get(eWithdraw, ["currency_code", "text"], "");
export const getEWithdrawCurrencySymbolText = (eWithdraw) =>
    _.get(eWithdraw, ["currency_code", "symbol"], "");
export const getEWithdrawItems = (eWithdraw) =>
    _.get(eWithdraw, ["items"], "");

export const getEWithdrawContractReference = (eWithdraw) =>
    _.get(eWithdraw, ["contract", "contract_reference"], "");
export const getEWithdrawTotalOutstandingAmountText = (eWithdraw) =>
    _.get(eWithdraw, ["contract", "total_outstanding_amount", "text"], "");
export const getEWithdrawTotalOutstandingAmountFullText = (eWithdraw) =>
    _.get(eWithdraw, ["contract", "total_outstanding_amount", "full_text"], "");
export const getEWithdrawTotalOutstandingBalanceText = (eWithdraw) =>
    _.get(eWithdraw, ["contract", "total_outstanding_balance", "text"], "");
export const getEWithdrawTotalOutstandingBalanceFullText = (eWithdraw) =>
    _.get(eWithdraw, ["contract", "total_outstanding_balance", "full_text"], "");
export const getEWithdrawTransactionCategory = (eWithdraw) =>
    _.get(eWithdraw, ["contract", "transaction_category", "text"], "");
export const getEWithdrawTransactionType = (eWithdraw) =>
    _.get(eWithdraw, ["contract", "transaction_type"], "");
export const getEWithdrawTransactionAmountText = (eWithdraw) =>
    _.get(eWithdraw, ["transaction_amount", "text"], "");
export const getEWithdrawTransactionAmountFullText = (eWithdraw) =>
    _.get(eWithdraw, ["transaction_amount", "full_text"], "");
export const getEWithdrawStockCode = (eWithdraw) =>
    _.get(eWithdraw, ["contract", "stock_code"], "");
export const getEWithdrawStockName = (eWithdraw) =>
    _.get(eWithdraw, ["contract", "stock_name"], "");

export const getEWithdrawCancelLink =eWithdraw => _.get(eWithdraw,['cancel_link'],[])
export const getEWithdrawIsCancellable =eWithdraw => _.get(eWithdraw,['is_cancellable'],false)
export const getEWithdrawMetaDataCancelLink =eWithdraw => _.get(eWithdraw,['_metadata','cancel_link'],[])
export const getEWithdrawMetaDataIsCancellable =eWithdraw => _.get(eWithdraw,['_metadata','is_cancellable'],false)
